import React, { ReactElement } from 'react';
import PatientsOverview from '../../../components/patient/PatientsOverview';

const Patients = (): ReactElement => {
  return <PatientsOverview variant="admin" />;
};

export default Patients;
